// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__HZ6Fg","logo":"header_logo__3iSgw","title":"header_title__3EkoF"};